<template>
  <v-container fluid class="pa-0">
    <v-layout row wrap>
      <v-flex xs12 v-if="lAction === 'view'" class="pa-2">
        <v-layout row wrap>
          <v-flex xs6>
            <v-text-field
            class="pa-0 mt-1"
            append-icon="search"
            :placeholder="$vuetify.breakpoint.smAndUp?'Search by Incident class, Description, etc.':'Search'"
            single-line
            hide-details
            v-model="search"
            clearable
            ></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-download-as
            :headers="incidentHeaderSm"
            :items="incidentList"
            title="Incidents List"
            :landscape="true"
            ></v-download-as>
          </v-flex>
          <v-flex xs12>
            <v-data-table
            :headers="$vuetify.breakpoint.smAndUp ? incidentHeaderSm : incidentHeader"
            :items="incidentList"
            class="elevation-3 mt-3"
            hide-actions
            :search="search"
            >
              <template slot="items" slot-scope="props">
                <tr @click="prepareUpdate(props.item)">
                  <td>{{ handy.formatDate(props.item.incident_on) }}</td>
                  <td>{{ props.item.incident_type }}</td>
                  <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.incident_class }}</td>
                  <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.incident_desc }}</td>
                  <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.created_by_name }}</td>
                  <td v-if="$vuetify.breakpoint.smAndUp">{{ handy.formatDate(props.item.created_on) }}</td>
                  <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.incident_status }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
          <v-flex xs12>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat @click.native="showPastIncidents">View Past Incidents</v-btn>
            </v-card-actions>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12>
        <v-container v-if="lAction === 'create' || lAction === 'update'" grid-list-md class="pa-1">
          <v-layout row wrap>
            <v-flex xs12>
              <v-form ref="lForm" id="form" @submit.prevent="saveChanges(lAction)">
                <v-card flat>
                  <v-flex xs12 sm9 mx-auto>
                    <v-card-text class="pt-0">
                      <v-layout row wrap>
                        <v-flex xs12 sm6>
                          <v-radio-group
                          row class="pa-0" v-model="lIncident.incident_type"
                          hide-details
                          >
                            <v-flex xs6 v-for="(type, i) in incidentTypes" :key="i">
                              <v-radio
                              :label="type"
                              :value="type"
                              ></v-radio>
                            </v-flex>
                          </v-radio-group>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-select
                          v-model="lIncident.incident_class_id"
                          label="Incident class"
                          :items="incidentClass.filter(rec => rec.incident_type === lIncident.incident_type)"
                          item-text="incident_class"
                          item-value="incident_class_id"
                          :rules="[rules.required]"
                          ></v-select>
                        </v-flex>
                        <v-flex xs6 sm3>
                          <v-dialog ref="incidentOnDate"
                          persistent v-model="incidentOnDate"
                          max-width="290px"
                          :return-value.sync="lIncident.incidentDt"
                          >
                            <v-text-field
                            slot="activator" :label="lIncident.incident_type && lIncident.incident_type.includes('Outage') ? 'Outage start dt' : 'Incident date'"
                            v-model="lIncident.incidentDt"
                            append-icon="event"
                            readonly clearable
                            hide-details
                            :rules="[rules.required]"
                            ></v-text-field>
                            <v-date-picker v-model="lIncident.incidentDt" scrollable
                            first-day-of-week="1" :max="today"
                            >
                              <v-spacer></v-spacer>
                              <v-btn flat @click="incidentOnDate = false">Cancel</v-btn>
                              <v-btn flat color="accent" @click="$refs.incidentOnDate.save(lIncident.incidentDt)">OK</v-btn>
                            </v-date-picker>
                          </v-dialog>
                        </v-flex>
                        <v-flex xs6 sm3>
                          <v-dialog
                          ref="incidentTime"
                          persistent
                          v-model="incidentTime"
                          max-width="290px"
                          lazy
                          :return-value.sync="lIncident.incidentTime"
                          >
                            <v-text-field
                            slot="activator"
                            :label="lIncident.incident_type && lIncident.incident_type.includes('Outage') ? 'Time' : 'Incident time'"
                            v-model="lIncident.incidentTime"
                            append-icon="access_time"
                            clearable
                            hide-details
                            readonly
                            :rules="[rules.required]"
                            ></v-text-field>
                            <v-time-picker v-model="lIncident.incidentTime">
                              <v-spacer></v-spacer>
                              <v-btn flat @click="incidentTime = false">Cancel</v-btn>
                              <v-btn flat color="accent" @click="$refs.incidentTime.save(lIncident.incidentTime)">OK</v-btn>
                            </v-time-picker>
                          </v-dialog>
                        </v-flex>
                        <v-flex xs6 sm3 v-if="lIncident.incident_type && lIncident.incident_type.includes('Outage')">
                          <v-dialog ref="incidentEndDate"
                          persistent v-model="incidentEndDate"
                          max-width="290px"
                          :return-value.sync="lIncident.incidentDt"
                          >
                            <v-text-field
                            slot="activator" label="Outage end dt"
                            v-model="lIncident.incidentEndDate"
                            append-icon="event"
                            readonly clearable
                            hide-details
                            ></v-text-field>
                            <v-date-picker v-model="lIncident.incidentEndDate" scrollable
                            first-day-of-week="1" :max="today"
                            >
                              <v-spacer></v-spacer>
                              <v-btn flat @click="incidentEndDate = false">Cancel</v-btn>
                              <v-btn flat color="accent" @click="$refs.incidentEndDate.save(lIncident.incidentEndDate)">OK</v-btn>
                            </v-date-picker>
                          </v-dialog>
                        </v-flex>
                        <v-flex xs6 sm3 v-if="lIncident.incident_type && lIncident.incident_type.includes('Outage')">
                          <v-dialog
                          ref="incidentEndTime"
                          persistent
                          v-model="incidentEndTime"
                          max-width="290px"
                          lazy
                          :return-value.sync="lIncident.incidentEndTime"
                          >
                            <v-text-field
                            slot="activator"
                            label="Time"
                            v-model="lIncident.incidentEndTime"
                            append-icon="access_time"
                            clearable
                            hide-details
                            readonly
                            ></v-text-field>
                            <v-time-picker v-model="lIncident.incidentEndTime">
                              <v-spacer></v-spacer>
                              <v-btn flat @click="incidentEndTime = false">Cancel</v-btn>
                              <v-btn flat color="accent" @click="$refs.incidentEndTime.save(lIncident.incidentEndTime)">OK</v-btn>
                            </v-time-picker>
                          </v-dialog>
                        </v-flex>
                        <v-flex v-else sm6>
                        </v-flex>
                        <v-flex xs12 sm6 class="pb-3" v-if="lIncident.incident_type === 'Accident'">
                          <v-radio-group
                          v-model="lIncident.is_perm_staff"
                          hide-details
                          row
                          >
                            <v-flex xs6>
                              <v-radio label="Permanent Staff" value="true"></v-radio>
                            </v-flex>
                            <v-flex xs6>
                              <v-radio label="Temporary Staff" value="false"></v-radio>
                            </v-flex>
                          </v-radio-group>
                        </v-flex>
                        <v-flex xs12 sm6 v-if ="lIncident.incident_type === 'Accident' && lIncident.is_perm_staff === 'true'">
                          <v-select
                          v-model="lIncident.staff_id"
                          label="Staff name"
                          :items="staffList"
                          item-text="staff_name"
                          item-value="staff_id"
                          :rules="[rules.required]"
                          hide-details
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 sm6 v-else-if="lIncident.incident_type === 'Accident'">
                          <v-text-field
                          v-model="lIncident.temp_staff_name"
                          label="Staff name"
                          hide-details
                          :rules="[rules.required]"
                          maxlength="50"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-textarea
                          class="mt-2"
                          v-model="lIncident.incident_desc"
                          label="Incident description"
                          :rules="[rules.required]"
                          rows="3"
                          outline
                          maxlength="2000"
                          hide-details
                          ></v-textarea>
                        </v-flex>
                        <v-flex xs6>
                          <v-select
                          v-model="lIncident.severity"
                          label="Severity"
                          :items="['Low', 'Medium', 'High']"
                          :rules="[rules.required]"
                          hide-details
                          ></v-select>
                        </v-flex>
                        <v-flex xs6>
                          <v-select
                          v-model="lIncident.incident_status"
                          label="Status"
                          :items="['Open', 'Closed']"
                          ></v-select>
                        </v-flex>
                        <v-flex xs12>
                          <v-expansion-panel>
                            <v-expansion-panel-content>
                              <div slot="header">
                                <span class="primary--text subheading"><strong>Reporting Of Incident</strong></span>
                                <div class="caption"><i> (Major incidents/outages have to be reported to concern person based on SOP, optional otherwise)</i></div>
                              </div>
                              <v-card-text class="pt-0">
                                <v-layout row wrap>
                                  <v-flex xs6 sm3>
                                    <v-dialog ref="reportOnDate"
                                    persistent v-model="reportOnDate"
                                    max-width="290px"
                                    :return-value.sync="lIncident.reportDt"
                                    >
                                      <v-text-field
                                      slot="activator" label="Reported date"
                                      v-model="lIncident.reportDt"
                                      append-icon="event"
                                      readonly clearable
                                      hide-details
                                      ></v-text-field>
                                      <v-date-picker v-model="lIncident.reportDt" scrollable
                                      first-day-of-week="1"
                                      :max="today"
                                      >
                                        <v-spacer></v-spacer>
                                        <v-btn flat @click="reportOnDate = false">Cancel</v-btn>
                                        <v-btn flat color="accent" @click="$refs.reportOnDate.save(lIncident.reportDt)">OK</v-btn>
                                      </v-date-picker>
                                    </v-dialog>
                                  </v-flex>
                                  <v-flex xs6 sm3>
                                    <v-dialog
                                    ref="reportedTime"
                                    persistent
                                    v-model="reportedTime"
                                    max-width="290px"
                                    lazy
                                    :return-value.sync="lIncident.reportTime"
                                    >
                                      <v-text-field
                                      slot="activator"
                                      label="Reported time"
                                      v-model="lIncident.reportTime"
                                      append-icon="access_time"
                                      clearable
                                      hide-details
                                      readonly
                                      ></v-text-field>
                                      <v-time-picker v-model="lIncident.reportTime">
                                        <v-spacer></v-spacer>
                                        <v-btn flat @click="reportedTime = false">Cancel</v-btn>
                                        <v-btn flat color="accent" @click="$refs.reportedTime.save(lIncident.reportTime)">OK</v-btn>
                                      </v-time-picker>
                                    </v-dialog>
                                  </v-flex>
                                  <v-flex xs12 sm6>
                                    <v-text-field
                                    v-model="lIncident.reported_to"
                                    label="Reported to"
                                    hide-details
                                    maxlength="30"
                                    ></v-text-field>
                                  </v-flex>
                                </v-layout>
                              </v-card-text>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-flex>
                        <v-flex xs12>
                          <v-expansion-panel>
                            <v-expansion-panel-content>
                              <div slot="header">
                                <span class="primary--text subheading"><strong>Root Cause and Preventive Measure</strong></span>
                                <div class="caption"><i> (Filled-in after investigation; optional if no investigation required)</i></div>
                              </div>
                              <v-card-text class="pt-0">
                                <v-layout row wrap>
                                  <v-flex xs12 sm6>
                                    <v-dialog ref="investigatedDate"
                                    persistent v-model="investigatedDate"
                                    max-width="290px"
                                    :return-value.sync="lIncident.investigated_dt"
                                    >
                                      <v-text-field
                                      slot="activator" label="Investigated date"
                                      v-model="lIncident.investigated_dt "
                                      append-icon="event"
                                      readonly clearable
                                      hide-details
                                      ></v-text-field>
                                        <v-date-picker v-model="lIncident.investigated_dt" scrollable
                                        first-day-of-week="1"
                                        :min="lIncident.incidentDt" :max="today"
                                        >
                                        <v-spacer></v-spacer>
                                        <v-btn flat @click="investigatedDate = false">Cancel</v-btn>
                                        <v-btn flat color="accent" @click="$refs.investigatedDate.save(lIncident.investigated_dt)">OK</v-btn>
                                      </v-date-picker>
                                    </v-dialog>
                                  </v-flex>
                                  <v-flex xs12 sm6>
                                    <v-text-field
                                    v-model="lIncident.investigated_by "
                                    label="Investigated by"
                                    hide-details
                                    maxlength="50"
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex xs12>
                                    <v-textarea
                                    class="mt-2"
                                    v-model="lIncident.rca"
                                    label="RCA"
                                    hide-details
                                    rows="3"
                                    outline
                                    maxlength="2000"
                                    ></v-textarea>
                                  </v-flex>
                                  <v-flex xs12>
                                    <v-textarea
                                    class="mt-2"
                                    v-model="lIncident.corrective_action"
                                    label="Corrective action"
                                    rows="3"
                                    outline
                                    hide-details
                                    maxlength="2000"
                                    ></v-textarea>
                                  </v-flex>
                                </v-layout>
                              </v-card-text>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-flex>
                        <v-flex xs12>
                          <input style="display:none" type="file" ref="fileInput"
                          accept=".xls, .xlsx, .pdf, .doc, .docx, image/png, image/gif, image/jpeg" multiple @change="loadFilesFromFileBrowser()"/>
                          <v-btn icon @click="pickFile"><v-icon>attach_file</v-icon></v-btn>
                          <span v-if="lIncident.files.filter(rec => rec.is_selected).length > 0">
                            <span v-for="(file, index) in lIncident.files" :key="index">
                              <v-chip v-model="file.is_selected" close @input="$forceUpdate()">
                                {{ file.file_name }}
                                <span v-if="!file.is_changed">
                                  <a :href="config.FM_SPACES_BASE_URL + file.file_url" download style="text-decoration: none;">
                                    <v-btn small icon class="mr-0 grey lighten-1 grey--text text--lighten-4">
                                      <v-icon small>file_download</v-icon>
                                    </v-btn>
                                  </a>
                                </span>
                              </v-chip>
                            </span>
                          </span>
                          <span v-else>Attachment if any<br /><span class="caption">(supports images, pdfs, docs and excels upto 20MB)</span></span>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn @click.stop="lAction = 'view'">cancel</v-btn>
                      <v-btn v-if="lAction === 'update'" @click.stop="deleteIncident">Delete</v-btn>
                      <v-btn type="submit" color="accent" :disabled="beingSaved">save</v-btn>
                      <v-btn @click="prepareViewForPdf()">View</v-btn>
                    </v-card-actions>
                  </v-flex>
                </v-card>
              </v-form>
            </v-flex>
          </v-layout>
        </v-container>

        <v-dialog v-model="showPastInc" max-width="1000px" persistent>
          <v-card flat scrollable>
            <v-card-title class="title grey lighten-4">
              <span>Closed incidents ({{pastIncidents.length}})</span>
              <v-spacer></v-spacer>
              <v-btn small icon @click.native="showPastInc = false; searchPast=''"><v-icon>close</v-icon></v-btn>
            </v-card-title>
            <v-card-text class="pa-0">
              <v-data-table
              :headers="$vuetify.breakpoint.smAndUp ? incidentHeaderSm : incidentHeader"
              :items="pastIncidents"
              class="elevation-3 mt-3"
              hide-actions
              :search="searchPast"
              >
                <template slot="items" slot-scope="props">
                  <tr @click="prepareUpdate(props.item)">
                    <td>{{ handy.formatDate(props.item.incident_on) }}</td>
                    <td>{{ props.item.incident_type }}</td>
                    <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.incident_class }}</td>
                    <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.incident_desc }}</td>
                    <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.created_by_name }}</td>
                    <td v-if="$vuetify.breakpoint.smAndUp">{{ handy.formatDate(props.item.created_on) }}</td>
                    <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.incident_status }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions class="grey lighten-4 caption">
              <v-layout row wrap>
                <v-flex xs6>
                  <v-text-field
                  append-icon="search"
                  hide-details
                  v-model="searchPast"
                  class="pa-0 ml-1"
                  placeholder="Search"
                  clearable
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-download-as
                  :headers="incidentHeaderSm"
                  :items="pastIncidents"
                  title="Closed incidents"
                  ></v-download-as>
                </v-flex>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="showPastIncView" max-width="1000px" persistent>
          <v-card>
            <v-card-title style="font-size: 17px; font-weight: bold" class="py-0 grey lighten-3">
              Incident View
              <v-spacer></v-spacer>
              <v-btn color="accent" @click="downloadAsPdf()">Save as Pdf</v-btn>
              <v-btn icon small @click="showPastIncView = false"><v-icon>close</v-icon></v-btn>
            </v-card-title>
            <v-card-text class="pa-0">
              <v-flex xs12>
                <v-container grid-list-md class="pa-0">
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-form ref="lForm" id="form">
                        <v-card flat>
                          <v-flex xs12 sm11 mx-auto id="pdf_report">
                            <v-card-text class="pt-0">
                              <v-layout row wrap>
                                <v-flex xs12 class="pt-3">
                                  <div>
                                  <img height="100" width="250" src="../../static/img/logo/integra_logo.png"/> </div>
                                  <div style="text-align:center; font-size: 24px" class="accent--text font-weight-bold">{{ comm_det[0] ? comm_det[0].comm_name : '-'  }}</div>

                                  <div style="text-align:center; font-size: 16px" class="pt-1 font-weight-bold">Incident Report</div>
                                  <div class="pt-3"><hr /></div>
                                </v-flex>
                                <v-flex xs12 class="pt-3">
                                  <v-layout row wrap>
                                    <v-flex xs12 class="pt-3">
                                      <div class="subheading font-weight-bold">Incident Details</div>
                                    </v-flex>
                                    <v-flex xs3>
                                      <div class="caption font-weight-bold">Incident Type</div>
                                      <div class="blue--text font-weight-bold">{{ lIncident.incident_type ? lIncident.incident_type : ''}}</div>
                                    </v-flex>
                                    <v-flex xs3>
                                      <div class="caption font-weight-bold">Incident Class</div>
                                      <div class="blue--text font-weight-bold">{{incidentClass.filter(rec => rec.incident_type === lIncident.incident_type && rec.incident_class_id === lIncident.incident_class_id)[0] ? incidentClass.filter(rec => rec.incident_type === lIncident.incident_type && rec.incident_class_id === lIncident.incident_class_id)[0].incident_class : ''}}</div>
                                    </v-flex>
                                    <v-flex xs3>
                                      <div class="caption font-weight-bold">Severity</div>
                                      <div class="blue--text font-weight-bold">{{lIncident.severity ? lIncident.severity : '-'}}</div>
                                    </v-flex>
                                    <v-flex xs3>
                                      <div class="caption font-weight-bold">Status</div>
                                      <div class="blue--text font-weight-bold">{{lIncident.incident_status ? lIncident.incident_status : '-'}}</div>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 class="pt-3">
                                  <v-layout row wrap>
                                    <v-flex xs3>
                                      <div class="caption font-weight-bold">{{ lIncident.incident_type ? lIncident.incident_type.includes('Outage') ? 'Outage Start Date' : 'Incident Date' : '' }}</div>
                                      <div class="blue--text font-weight-bold">{{lIncident.incidentDt ? lIncident.incidentDt : '-'}}</div>
                                    </v-flex>
                                    <v-flex xs3>
                                      <div class="caption font-weight-bold">{{ lIncident.incident_type ? lIncident.incident_type.includes('Outage') ? 'Outage Time' : 'Incident Time' : '' }}</div>
                                      <div class="blue--text font-weight-bold">{{lIncident.incidentTime ? lIncident.incidentTime : '-'}}</div>
                                    </v-flex>
                                    <v-flex xs3 v-if="lIncident.incident_type ? lIncident.incident_type.includes('Outage') ? true : false : false">
                                      <div class="caption font-weight-bold">Outage End Date</div>
                                      <div class="blue--text font-weight-bold">{{lIncident.incidentEndDate ? lIncident.incidentEndDate : '-'}}</div>
                                    </v-flex>
                                    <v-flex xs3 v-if="lIncident.incident_type ? lIncident.incident_type.includes('Outage') ? true : false : false">
                                      <div class="caption font-weight-bold">Outage End Time</div>
                                      <div class="blue--text font-weight-bold">{{lIncident.incidentEndTime ? lIncident.incidentEndTime : '-'}}</div>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm6 class="pt-3" v-if="lIncident.incident_type === 'Accident'">
                                  <v-flex xs4>
                                    <div class="caption font-weight-bold">Staff Type</div>
                                    <div class="blue--text font-weight-bold">{{ lIncident.is_perm_staff ? 'Permanent Staff' : 'Temporary Staff' }}</div>
                                  </v-flex>
                                </v-flex>
                                <v-flex xs12 sm6 v-if ="lIncident.incident_type === 'Accident' && lIncident.is_perm_staff === 'true'">
                                  <v-flex xs4>
                                    <div class="caption font-weight-bold">Staff Name</div>
                                    <div class="blue--text font-weight-bold">{{ staffList.filter(rec => rec.staff_id === lIncident.staff_id)[0] ? staffList.filter(rec => rec.staff_id === lIncident.staff_id)[0].staff_name : '' }}</div>
                                  </v-flex>
                                </v-flex>
                                <v-flex xs12 sm6 v-else-if="lIncident.incident_type === 'Accident'">
                                  <v-flex xs4>
                                    <div class="caption font-weight-bold">Temp Staff Name</div>
                                    <div class="blue--text font-weight-bold">{{ lIncident.temp_staff_name ? lIncident.temp_staff_name : '' }}</div>
                                  </v-flex>
                                </v-flex>
                                <v-flex xs12 class="pt-3">
                                  <div class="caption font-weight-bold">Incident Description</div>
                                  <div class="blue--text font-weight-bold">{{lIncident.incident_desc ? lIncident.incident_desc : '-'}}</div>
                                </v-flex>
                                <v-flex xs12 class="pt-3">
                                  <div slot="header">
                                    <span class="subheading font-weight-bold"><strong>Reporting Of Incident</strong></span>
                                    <div class="caption"><i> (Major incidents/outages have to be reported to concern person based on SOP, optional otherwise)</i></div>
                                  </div>
                                  <v-layout row wrap>
                                    <v-flex xs3>
                                      <div class="caption font-weight-bold">Reported Date</div>
                                      <div class="blue--text font-weight-bold">{{lIncident.reportDt ? lIncident.reportDt : '-'}}</div>
                                    </v-flex>
                                    <v-flex xs3>
                                      <div class="caption font-weight-bold">Reported Time</div>
                                      <div class="blue--text font-weight-bold">{{lIncident.reportTime ? lIncident.reportTime : '-'}}</div>
                                    </v-flex>
                                    <v-flex xs3>
                                      <div class="caption font-weight-bold">Reported To</div>
                                      <div class="blue--text font-weight-bold">{{lIncident.reported_to ? lIncident.reported_to : '-'}}</div>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 class="pt-3">
                                  <div slot="header">
                                    <span class="subheading font-weight-bold"><strong>Root Cause and Preventive Measure</strong></span>
                                    <div class="caption"><i> (Filled-in after investigation; optional if no investigation required)</i></div>
                                  </div>
                                  <v-layout row wrap>
                                    <v-flex xs6>
                                      <div class="caption font-weight-bold">Investigated Date</div>
                                      <div class="blue--text font-weight-bold">{{lIncident.investigated_dt ? lIncident.investigated_dt : '-'}}</div>
                                    </v-flex>
                                    <v-flex xs6>
                                      <div class="caption font-weight-bold">Investigated By</div>
                                      <div class="blue--text font-weight-bold">{{lIncident.investigated_by ? lIncident.investigated_by : '-'}}</div>
                                    </v-flex>
                                    <v-flex xs12 class="pt-3">
                                      <div class="subheading font-weight-bold">Root Cause Analysis (RCA)</div>
                                      <div class="blue--text font-weight-bold">{{lIncident.rca ? lIncident.rca : '-'}}</div>
                                    </v-flex>
                                    <v-flex xs12 class="pt-3">
                                      <div class="subheading font-weight-bold">Corrective Action</div>
                                      <div class="blue--text font-weight-bold">{{lIncident.corrective_action ? lIncident.corrective_action : '-'}}</div>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 class="pt-3">
                                  <div class="pt-3"><hr /></div>
                                  <div style="text-align:center; font-size: 12px" class="pt-1">--- end of incident report ---</div>
                                </v-flex>
                                <!-- <v-flex xs12>
                                  <input style="display:none" type="file" ref="fileInput"
                                  accept=".xls, .xlsx, .pdf, .doc, .docx, image/png, image/gif, image/jpeg" multiple @change="loadFilesFromFileBrowser()"/>
                                  <v-btn icon @click="pickFile"><v-icon>attach_file</v-icon></v-btn>
                                  <span v-if="lIncident.files && lIncident.files.filter(rec => rec.is_selected).length > 0">
                                    <span v-for="(file, index) in lIncident.files" :key="index">
                                      <v-chip v-model="file.is_selected" close @input="$forceUpdate()">
                                        {{ file.file_name }}
                                        <span v-if="!file.is_changed">
                                          <a :href="config.STATIC_FILES_DIR + file.file_url" download style="text-decoration: none;">
                                            <v-btn small icon class="mr-0 grey lighten-1 grey--text text--lighten-4">
                                              <v-icon small>file_download</v-icon>
                                            </v-btn>
                                          </a>
                                        </span>
                                      </v-chip>
                                    </span>
                                  </span>
                                  <span v-else>Attachment if any<br /><span class="caption">(supports images, pdfs, docs and excels upto 20MB)</span></span>
                                </v-flex> -->
                              </v-layout>
                            </v-card-text>
                          </v-flex>
                        </v-card>
                      </v-form>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-btn
        :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:20px; right:15px;':'bottom:15px; right:15px;')"
        dark fab fixed color="accent" v-if="lAction === 'view'"
        @click.native="prepareCreate">
        <v-icon>add</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>

    <!-- snack bar for reporting -->
    <v-snackbar :color="sbarCol" v-model="sbar"
    :timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
    </v-snackbar>
  </v-container>
</template>

<script>
import handy from '@/utils/handy'
import config from '@/config/app-cfg'
var html2pdf = require('html2pdf.js')
import VDownloadAs from './VDownloadAs.vue'

export default {
  components:
  {
    'v-download-as': VDownloadAs
  },
  data () {
    return {
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      search: '',
      searchPast: '',
      config: config,
      handy: handy,
      rules: handy.rules,
      lAction: 'view',
      lIncident: {},
      incidentList: [],
      pastIncidents: [],
      incidentClass: [],
      incidentTypes: [],
      staffList: [],
      incidentTime: false,
      incidentOnDate: false,
      incidentEndDate: false,
      incidentEndTime: false,
      reportOnDate: false,
      reportedTime: false,
      investigatedDate: false,
      beingSaved: false,
      showPastInc: false,
      incidentHeaderSm: [
        { text: 'Incident On', value: 'incident_on' },
        { text: 'Type', value: 'incident_type' },
        { text: 'Incident Class', value: 'incident_class' },
        { text: 'Description', value: 'incident_desc' },
        { text: 'Created By', value: 'created_by' },
        { text: 'Created On', value: 'created_on' },
        { text: 'Status', value: 'incident_status' }
      ],
      incidentHeader: [
        { text: 'Incident On', value: 'incident_on' },
        { text: 'Type', value: 'incident_type' }
      ],
      showPastIncView: false,
      comm_det: []
    }
  },
  computed: {
    today: function () {
      return handy.formatDBDate(Date())
    }
  },
  mounted () {
    this.loadIncidents()
    this.loadIncidentClass()
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    loadIncidents (status = 'Open') {
      var qry = {
        params: {
          user_id: config.USER_ID,
          comm_id: config.COMM_ID,
          incident_status: status
        }
      }
      this.axios.get(config.API_URL + '/getIncidentsByCommId/', qry)
      .then(response => {
        if (status === 'Open') {
          this.incidentList = response.data
        } else {
          this.pastIncidents = response.data
        }
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    loadIncidentAttachment (curIncident) {
      var path = require('path')
      var qry = {
        params: {
          incident_id: curIncident.incident_id
        }
      }
      curIncident.files = []
      this.axios.get(config.API_URL + '/getAttachmentByIncidentId/', qry)
      .then(response => {
        response.data.forEach((rec) => {
          curIncident.files.push({
            file_url: rec.file_url,
            file_name: path.basename(rec.file_url),
            is_selected: true,
            is_changed: false
          })
        })
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadIncidentClass () {
      this.axios.get(config.API_URL + '/getIncidentClass/')
      .then(response => {
        this.incidentClass = response.data
        if (config.COMM_COUNTRY_CODE === 'MY') {
          this.incidentClass = response.data.filter(rec => rec.incident_class !== 'MTI: Medical Treatment Injury' && rec.incident_class !== 'PD: Permanent Disability')
        } else {
          this.incidentClass = response.data
        }
        this.incidentTypes = handy.unique(this.incidentClass.map(rec => rec.incident_type)).sort()
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.incidentClass = []
      })
    },
    showPastIncidents () {
      this.loadIncidents('Closed')
      this.showPastInc = true
    },
    loadStaffList () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getStaffByCommId/', qry)
      .then(response => {
        this.staffList = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
        this.staffList = []
      })
    },
    prepareCreate () {
      this.lIncident = {
        incident_type: this.incidentTypes[1],
        incident_class_id: '',
        incident_status: 'Open',
        incident_on: null,
        incidentDt: '',
        incidentTime: '',
        incidentEndDate: '',
        incidentEndTime: '',
        comm_id: config.COMM_ID,
        is_perm_staff: 'true',
        staff_id: '',
        temp_staff_name: '',
        severity: 'Medium',
        incident_desc: '',
        reported_on: null,
        reportDt: '',
        reportTime: '',
        reported_to: '',
        investigated_by: '',
        investigated_dt: null,
        rca: '',
        corrective_action: '',
        created_by: config.USER_ID,
        files: []
      }
      this.loadStaffList()
      this.lAction = 'create'
    },
    saveChanges (action) {
      // validate and save Changes
      if (action === 'create' || action === 'update') {
        if (!this.$refs.lForm.validate()) {
          return
        }
        this.beingSaved = true
        this.lIncident.created_by = config.USER_ID
        this.lIncident.comm_id = config.COMM_ID
        this.lIncident.incident_on = handy.formatDBDateTime(this.lIncident.incidentDt + ' ' + this.lIncident.incidentTime)
        this.lIncident.incident_end = this.lIncident.incidentEndDate ? handy.formatDBDateTime(this.lIncident.incidentEndDate + ' ' + this.lIncident.incidentEndTime) : null
        this.lIncident.reported_on = this.lIncident.reportDt ? handy.formatDBDateTime(this.lIncident.reportDt + ' ' + this.lIncident.reportTime) : null
        this.lIncident.is_perm_staff = this.lIncident.is_perm_staff ? '1' : '0'
        this.axios.post(config.API_URL + '/incidents/' + action, this.lIncident)
        .then(response => {
          this.lIncident.incident_id = response.data
          this.loadIncidents()
          this.lAction = 'view'
          this.beingSaved = false
        })
        .catch(err => {
          this.msg(err.response.data, 0)
          this.beingSaved = false
        })
      }
    },
    deleteIncident () {
      if (!confirm('Sure, you want to delete the incident?')) {
        return
      }
      // up in db
      this.beingSaved = true
      this.axios.post(config.API_URL + '/incidents/delete', this.lIncident)
      .then(response => {
        this.idx = this.incidentList.findIndex(rec => rec.incident_id === this.lIncident.incident_id)
        this.incidentList.splice(this.idx, 1)
        this.lAction = 'view'
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data, 0)
        this.beingSaved = false
      })
    },
    prepareUpdate (curIncident) {
      this.loadIncidentAttachment(curIncident)
      this.lIncident = Object.assign({}, curIncident)
      this.lIncident.updated_by = config.USER_ID
      this.lIncident.incidentDt = handy.formatDBDate(this.lIncident.incident_on)
      this.lIncident.incidentTime = handy.getLongTime(this.lIncident.incident_on)
      this.lIncident.incidentEndDate = curIncident.incident_end ? handy.formatDBDate(curIncident.incident_end) : null
      this.lIncident.incidentEndTime = this.lIncident.incident_end ? handy.getLongTime(curIncident.incident_end) : null
      this.lIncident.reportDt = curIncident.reported_on ? handy.formatDBDate(curIncident.reported_on) : null
      this.lIncident.reportTime = this.lIncident.reported_on ? handy.getLongTime(curIncident.reported_on) : null
      this.lIncident.investigated_dt = curIncident.investigated_dt ? handy.formatDBDate(curIncident.investigated_dt) : null
      this.lIncident.staff_id = curIncident.staff_id
      this.lIncident.is_perm_staff = curIncident.is_perm_staff ? 'true' : 'false'
      this.lIncident.staff_id = this.lIncident.staff_id || ''
      this.lIncident.temp_staff_name = this.lIncident.temp_staff_name || ''
      this.loadStaffList()
      this.lAction = 'update'
      this.showPastInc = false
    },
    prepareViewForPdf () {
      var qry = {
        params: {
          comm_id: this.lIncident.comm_id
        }
      }
      this.comm_det = []
      this.axios.get(config.API_URL + '/getCommDetailsByID/', qry)
      .then(response => {
        this.comm_det = response.data
      })
      .catch(err => {
        this.msg(err, true)
      })
      this.showPastIncView = true
    },
    pickFile () {
      this.$refs.fileInput.click()
    },
    loadFilesFromFileBrowser () {
      const files = event.target.files
      Array.from(files).forEach((file) => {
        const fileReader = new FileReader()
        const getResult = new Promise(resolve => {
          fileReader.onload = e => {
            this.lIncident.files.push({
              file_url: e.target.result.split(',')[1],
              file_name: file.name,
              is_selected: true,
              is_changed: true
            })
            this.$forceUpdate()
          }
        })
        fileReader.readAsDataURL(file)
        return getResult.then(file => {
          return file
        })
      })
    },
    downloadAsPdf () {
      // pdf options
      let opt = {
        margin: 9,
        filename: 'IncidentReport',
        image: { type: 'jpeg', quality: 0.95 },
        html2canvas: { scale: 2.5, dpi: 120, letterRendering: true, width: 747 },
        jsPDF: { format: 'letter' },
        pagebreak: { mode: ['avoid-all', 'legacy'] }
      }

      var canvas = document.getElementById('pdf_report')
      html2pdf().from(canvas).set(opt).toPdf().get('pdf').then(function (pdf) {
        var totalPages = pdf.internal.getNumberOfPages()

        for (var i = 1; i <= totalPages; i++) {
          pdf.setPage(i)
          pdf.setFontSize(8)
          pdf.text('Page ' + i + ' of ' + totalPages, pdf.internal.pageSize.getWidth() - 25, pdf.internal.pageSize.getHeight() - 5)
        }
      }).save()
    }
  }
}
</script>

<style>
.my-label-text-size .v-label {
  font-size: 14px !important;
}
img {
  float: right;
}
</style>



// WEBPACK FOOTER //
// Incidents.vue?f9641946